import React from 'react';
import '../css/Header&Footer.css';

function Header() {
    return (
        <h1 id="header-title" className="header-nav-color">James Alan Cone</h1>
    );
  }
  // Export Header
  export default Header;